var _g, _g2, _g3, _g4, _path, _g5, _path2, _path3, _g6, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertZmelody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6388_228)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_6388_228)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.9928,
    cy: 133.704,
    rx: 53.1966,
    ry: 5.11238,
    transform: "rotate(-18.0832 95.9928 133.704)",
    fill: "#EF5878"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_6388_228)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.8724,
    cy: 53.6573,
    rx: 53.1966,
    ry: 4.92136,
    transform: "rotate(-20.5885 81.8724 53.6573)",
    fill: "#0068FE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6388_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2372 101.622C11.3089 104.354 10.6422 107.171 10.3163 110.021C9.98593 112.871 10.0153 115.756 10.4237 118.574C10.8457 121.389 11.6205 124.147 12.7914 126.723C13.9534 129.301 15.4925 131.696 17.318 133.841C20.9712 138.144 25.7512 141.368 30.8869 143.627C33.46 144.76 36.1327 145.666 38.8615 146.362C41.5961 147.039 44.3748 147.517 47.1761 147.833C57.0337 148.944 65.8976 147.816 80.5403 142.242C95.183 136.668 102.428 129.278 110.882 122.087L113.651 132.677C104.155 140.024 93.2553 145.269 81.8674 148.459C70.4845 151.625 58.461 152.767 46.7597 150.987C43.8395 150.525 40.9493 149.889 38.1159 149.049C35.2876 148.184 32.5244 147.108 29.8727 145.793C24.5852 143.174 19.7102 139.543 16.082 134.855C14.2691 132.517 12.7764 129.937 11.6936 127.201C10.6018 124.466 9.93508 121.582 9.63284 118.68C9.34786 115.771 9.45446 112.839 9.92184 109.974C10.3847 107.109 11.185 104.311 12.238 101.626L12.2372 101.622Z",
    fill: "url(#paint0_linear_6388_228)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_6388_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.103 79.688C171.023 76.9804 171.684 74.1893 172.007 71.3656C172.334 68.541 172.305 65.6825 171.9 62.8902C171.482 60.1003 170.714 57.3674 169.554 54.8144C168.403 52.2599 166.877 49.8865 165.069 47.7614C161.449 43.4979 156.712 40.3028 151.623 38.0644C149.073 36.9415 146.425 36.0435 143.721 35.3537C141.011 34.6832 138.257 34.2096 135.482 33.8967C124.359 32.7221 113.852 34.2878 101.382 39.4375C89.0538 44.5285 81.9518 52.1423 73.5752 59.2682L69.6096 48.9149C79.0196 41.6344 89.8206 36.4374 101.105 33.2763C112.385 30.1392 124.299 29.0068 135.894 30.7712C138.788 31.2293 141.652 31.8587 144.459 32.6918C147.262 33.5487 150 34.6153 152.628 35.9181C157.867 38.5127 162.698 42.1109 166.293 46.7569C168.09 49.0733 169.569 51.63 170.642 54.3413C171.724 57.0511 172.385 59.9089 172.684 62.7843C172.966 65.6673 172.861 68.5727 172.398 71.4119C171.939 74.2504 171.146 77.0233 170.103 79.6836L170.103 79.688Z",
    fill: "url(#paint1_linear_6388_228)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6388_228)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6388_228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 32,
    width: 74,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1149 34.3905L31.1836 37.9049C24.5737 39.0704 21.269 39.6531 17.9097 41.4052C14.2744 43.5041 11.7544 47.103 11.0254 51.237C10.528 54.9929 11.1108 58.2982 12.2762 64.9076L15.7906 84.8388C16.9561 91.4488 17.5387 94.7529 19.2909 98.1128C21.3898 101.748 24.9887 104.268 29.1226 104.997C32.8786 105.495 36.1833 104.912 42.7933 103.746L62.7246 100.232C69.3345 99.0664 72.6386 98.4838 75.9984 96.731C79.6338 94.6327 82.1538 91.0338 82.8828 86.8998C83.3801 83.1433 82.7975 79.8392 81.632 73.2292L78.1176 53.2979C76.9522 46.6885 76.3694 43.3833 74.6173 40.024C72.5184 36.3887 68.9195 33.8687 64.7855 33.1397C61.029 32.6423 57.7249 33.225 51.1149 34.3905Z",
    fill: "#672F8B"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6388_228)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.8571,
    height: 66.8571,
    transform: "translate(8.22858 41.9525) rotate(-10)",
    fill: "url(#paint2_linear_6388_228)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.8571,
    height: 66.8571,
    transform: "translate(8.22858 41.9525) rotate(-10)",
    fill: "url(#paint3_linear_6388_228)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9871 74.3034C57.5532 72.855 60.6923 73.4592 60.6923 73.4592L60.6941 73.4691C63.0072 70.377 61.8788 60.6074 61.1456 58.4828C61.1335 58.4479 61.1224 58.4149 61.1119 58.3837C60.9977 58.0422 60.9522 57.9063 60.2754 57.8473C59.7659 57.7975 59.0733 57.8275 58.3194 57.8602C56.8058 57.9258 55.0447 58.0021 54.0199 57.4648C51.1977 55.9851 49.7278 51.3676 51.1981 48.6085C51.7833 47.5115 52.7478 46.5321 54.4171 46.2377C58.9066 45.4359 60.4945 46.0165 62.5474 48.2465C65.8305 51.8169 68.1046 60.4727 67.2438 72.1503C66.3514 84.3458 59.1489 89.2835 53.2773 88.8128C49.6916 88.523 46.7773 85.7072 47.5645 81.5728C48.2097 78.201 51.1944 75.431 53.9871 74.3034ZM48.6348 49.4129C47.607 51.9506 48.5604 55.2658 50.7858 57.3118L50.8039 57.2983C50.8106 57.3044 50.8172 57.3105 50.8239 57.3165C51.1458 57.6094 51.426 57.8642 49.9703 58.0908C47.2986 58.5106 43.2651 59.6317 40.8177 60.6267C40.2245 60.8645 40.2367 60.934 40.3804 61.7488C41.0344 65.6906 41.2081 69.1741 40.4049 74.6125C39.3302 81.8814 36.0356 85.9149 30.251 86.4022C26.6062 86.7068 23.9075 84.0681 24.4117 80.8851C24.8341 78.1674 27.0829 75.6399 29.7833 74.5695C32.6193 73.4547 35.5866 73.7818 35.5866 73.7818C36.8687 71.4658 36.719 63.6443 34.6962 58.7964C34.508 58.3456 34.3431 57.9971 34.2113 57.7185C33.7099 56.6589 33.6874 56.6113 34.6779 55.7876C37.4037 53.5243 43.4475 50.2661 48.4024 48.1528C49.0898 47.8677 49.3551 47.8619 49.3867 48.0407C49.3984 48.1073 49.3095 48.2406 49.1808 48.4337C49.0214 48.6729 48.8008 49.0038 48.6348 49.4129Z",
    fill: "url(#paint4_linear_6388_228)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6388_228)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6388_228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 74,
    width: 76,
    height: 76
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.859 82.9749L133.405 77.3963C126.953 75.5463 123.727 74.6213 119.94 74.7235C115.752 75.0163 111.91 77.1463 109.442 80.5423C107.349 83.7001 106.423 86.9263 104.574 93.3776L98.995 112.832C97.145 119.284 96.2202 122.509 96.3222 126.297C96.6151 130.485 98.745 134.327 102.141 136.794C105.299 138.889 108.524 139.813 114.976 141.664L134.431 147.242C140.883 149.092 144.108 150.017 147.896 149.914C152.084 149.622 155.926 147.492 158.394 144.096C160.487 140.938 161.412 137.713 163.262 131.261L168.841 111.806C170.691 105.355 171.616 102.128 171.514 98.341C171.221 94.1535 169.091 90.3109 165.695 87.8435C162.536 85.7497 159.311 84.8249 152.859 82.9749Z",
    fill: "#672F8B"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6388_228)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.8571,
    height: 66.8571,
    transform: "translate(110.998 70.9714) rotate(16)",
    fill: "url(#paint5_linear_6388_228)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6388_228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.696 106.9C118.521 97.0495 128.796 91.3538 138.647 94.1784C148.497 97.003 154.193 107.278 151.368 117.129C148.544 126.979 138.269 132.675 128.418 129.85C118.567 127.026 112.872 116.751 115.696 106.9ZM139.645 90.6983C127.872 87.3225 115.592 94.1295 112.216 105.902C108.841 117.675 115.648 129.955 127.42 133.33C139.193 136.706 151.473 129.899 154.848 118.127C158.224 106.354 151.417 94.074 139.645 90.6983ZM137.551 101.819C137.452 100.797 136.153 100.425 135.527 101.239L131.199 106.875C131.008 107.123 130.722 107.282 130.41 107.312L123.337 107.996C122.315 108.095 121.943 109.394 122.757 110.019L128.393 114.348C128.642 114.539 128.8 114.824 128.83 115.136L129.514 122.21C129.613 123.232 130.912 123.604 131.537 122.79L135.866 117.154C136.057 116.905 136.342 116.747 136.654 116.717L143.728 116.033C144.75 115.934 145.122 114.635 144.308 114.009L138.672 109.681C138.423 109.49 138.265 109.204 138.235 108.892L137.551 101.819Z",
    fill: "url(#paint6_linear_6388_228)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6388_228",
    x: 14.5412,
    y: 85.6297,
    width: 162.903,
    height: 96.1482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.4286,
    result: "effect1_foregroundBlur_6388_228"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6388_228",
    x: 1.18564,
    y: 3.52991,
    width: 161.374,
    height: 100.255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.4286,
    result: "effect1_foregroundBlur_6388_228"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6388_228",
    x: 9.47577,
    y: 101.622,
    width: 104.176,
    height: 51.7486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.02857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6388_228"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_6388_228",
    x: 69.6096,
    y: 29.938,
    width: 103.23,
    height: 51.2929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.02857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6388_228"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6388_228",
    x: -2.34197,
    y: 19.7723,
    width: 98.5921,
    height: 98.5921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28527
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.996078 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6388_228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6388_228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6388_228",
    x: 81.9996,
    y: 60.4009,
    width: 103.837,
    height: 103.837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28527
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.934803 0 0 0 0 0.186942 0 0 0 0 0.345429 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6388_228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6388_228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6388_228",
    x1: 111.552,
    y1: 131.25,
    x2: 10.7221,
    y2: 104.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5878",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212631,
    stopColor: "#EF5878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6388_228",
    x1: 71.6897,
    y1: 50.3293,
    x2: 171.605,
    y2: 76.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D5AF7",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202928,
    stopColor: "#3D5AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722563,
    stopColor: "#EF5878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6388_228",
    x1: -1.67143,
    y1: -11.266,
    x2: 88.8799,
    y2: 11.2165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D71D6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6388_228",
    x1: 1.59184,
    y1: 66.8571,
    x2: 65.7891,
    y2: -1.01024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799422,
    stopColor: "#5350FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6388_228",
    x1: 68.529,
    y1: 94.141,
    x2: 38.8904,
    y2: 50.0651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6388_228",
    x1: -1.67143,
    y1: -11.266,
    x2: 88.8799,
    y2: 11.2165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D71D6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6388_228",
    x1: 142.438,
    y1: 145.956,
    x2: 133.054,
    y2: 91.5743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6388_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6388_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.3065,
    height: 54.3065,
    fill: "white",
    transform: "translate(114.915 78.4286) rotate(16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertZmelody);
export default __webpack_public_path__ + "static/media/convert_zmelody.55d3711a42af89b9f0efdb319e465363.svg";
export { ForwardRef as ReactComponent };